/* eslint-disable no-unused-vars */

import React from 'react'
import './App.css';
import Nav from './components/Nav'
import Main from './components/Main'
function App() {
  return (
    <>
      <div className="App">
        <Nav />
        <Main />
        <hr></hr>
      </div>
    </>
  );
}
export default App;
